import {TableContainer,Table,Thead, Icon,
    Tbody,Th,Tr,Td, Box,  Spacer,
    Spinner,
    Center
    } from '@chakra-ui/react';
import {MdCheckBox,MdCheckBoxOutlineBlank} from "react-icons/md";
import { useState, useEffect } from 'react';
import GruntPager from '../custom/GruntPager'; 
import { getOdlasci,getDolasci } from '../../util/apiMigracija';   

export default function MigracijaList({vrsta='o',onSelectChange,preselectedMigracijeId,size='xs',rowsPerPage=15}) {
    const [state,setState]=useState({migracije:[],errmsg:""})
    const [dataisloading, setDataisloading] = useState(true);
    const [prikaz, setPrikaz] = useState({rowsperpage:rowsPerPage,currpage:1,numOfRowsToShow:0,selectallgoveda:false,numberofselected:0})
    useEffect(() => {
      const getMigracije=async()=>{
        try {
            let res;
            setDataisloading(true);
            if (vrsta.toLowerCase()==="o") {
                res=await getOdlasci({_verificiran:true,responsedatatype:"app"});
            } else {
                res=await getDolasci({responsedatatype:"app"});
            }
            if (res.status===200) {
                
                setState({...state,migracije:await putSelectedInResult(res.res),errmsg:""}); 
                setPrikaz({...prikaz,numOfRowsToShow:res.res.length/*,numberofselected:_numselected*/});   
            } else {
                setState({...state,errmsg:res.message});    
            }
            
        } catch (error) {
            setState({...state,errmsg:error.message});
        } finally {
            setDataisloading(false);
        }
      }
      if (vrsta.toLowerCase()==="o" || vrsta.toLowerCase()==="d") {
        getMigracije();
      }
    }, [vrsta])

    const putSelectedInResult=async (arr)=>{
        let _r=[...arr]
        for (let i = 0; i < _r.length; i++) {
            const _fi=preselectedMigracijeId.findIndex((item)=>item===_r[i].migracija_id);
            if (_fi===-1) {
                _r[i].selected=false;    
            } else {
                _r[i].selected=true;
            }
            
            
        }
        return _r;
    }
    const onItemClick=(id)=>{
        const newMigracije=state.migracije.map((item)=>{
            if (item.migracija_id===id) {
                item.selected=!item.selected;
            }
            return item;
        })
        setState({...state,migracije:newMigracije});
        const _sel=newMigracije.filter((item)=>item.selected===true);
        const _selectedmigracijaid=[];
        _sel.forEach((item)=>_selectedmigracijaid.push(item.migracija_id));
        onSelectChange(_selectedmigracijaid);
    }

    const showData=()=>{
        if (dataisloading) {
            return (
                <Center>
                    <Spinner />
                </Center>                    
            )
        } else {
        return (
        <>
            <TableContainer>
                <Table size={'xs'}>
                    <Thead _hover={{cursor:'pointer'}}>
                        <Tr>
                            <Th w={'5%'} fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopLeftRadius={'sm'}></Th>
                            <Th w={'15%'} fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum</Th>
                            <Th w={'15%'} fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Vrsta</Th>
                            <Th w={'50%'} fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Posjednik</Th>
                            <Th w={'15%'} fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopRightRadius={'sm'}>Br goveda</Th>
                            
                        </Tr>
                    </Thead>
                <Tbody>
                    {state.migracije.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,index)=>{
                        
                            return (
                                <Tr  key={item.migracija_id}  bg={'white'} fontWeight={'normal'} color={'grunt2.700'}
                                        _hover={{bg:'gray.100',cursor:'pointer'}} h={'2rem'} 
                                        fontStyle={'normal'} onClick={()=>onItemClick(item.migracija_id)}>
                                            <Td fontSize={size} textAlign={'center'}>
                                            {item.selected?<Icon as={MdCheckBox}  boxSize={5}/>:<Icon as={MdCheckBoxOutlineBlank} boxSize={5}/>}
                                            </Td>
                                            <Td fontSize={size} textAlign={'center'}>{new Date(item.datum).toLocaleDateString('hr-HR')}</Td>
                                            <Td fontSize={size} textAlign={'center'}>{item.migracija_tip}</Td>
                                            <Td fontSize={size} textAlign={'center'}>{vrsta==="o"?item.dolposjednik:item.odlposjednik}</Td>
                                            <Td fontSize={size} textAlign={'center'}>{item.br_grla}</Td>
                                        </Tr>
                            )    
                        
                        
                    })}
                </Tbody>
                </Table>
            </TableContainer>
            <Spacer/>
            <Box mt={'0.5rem'}>
              <GruntPager currpage={prikaz.currpage} rowcount={prikaz.numOfRowsToShow} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
            </Box>
        </>
            )
        
        }
    }
    
  return (
    <Box>
        {showData()}
    </Box>
  )
}
